const getErrorMessage = (error: unknown) => {
	if (error instanceof Error) {
		if (error.message.includes('permissionTemplateId')) {
			return 'Missing permission template on one or more components'
		}
		if (error.message.includes('label')) {
			return 'Missing label on one or more components'
		}

		return error.message
	}
	return 'Error saving form. Please try again.'
}

export default getErrorMessage
